import React from 'react';
import './LegalFoundations.css';

function LegalFoundations() {
  return (
    <div className="legal-foundations">
      <div className="legal-header">
        <h1>Legal Foundations</h1>
        <p className="legal-subtitle">
          Comprehensive taxonomy of the United States legal system
        </p>
      </div>

      <div className="legal-content">
        <section className="legal-section">
          <h2>Legal System Hierarchy</h2>

          <div className="hierarchy-level">
            <h3>1. Constitutional Foundation (1787-1791)</h3>

            <div className="subsection">
              <h4>U.S. Constitution (1787)</h4>
              <ul>
                <li>Article I: Legislative Powers</li>
                <li>Article II: Executive Powers</li>
                <li>Article III: Judicial Powers</li>
                <li>Article IV: States Relations</li>
                <li>Article V: Amendment Process</li>
                <li>Article VI: Supremacy Clause</li>
                <li>Article VII: Ratification</li>
              </ul>
            </div>

            <div className="subsection">
              <h4>Bill of Rights (1791)</h4>
              <p>Amendments 1-10: Fundamental individual rights and limitations on government power</p>
            </div>

            <div className="subsection">
              <h4>Constitutional Amendments (1795-1992)</h4>
              <div className="amendments-grid">
                <div>Amendment 11: Judicial Limits (1795)</div>
                <div>Amendment 12: Electoral College (1804)</div>
                <div>Amendment 13: Abolition of Slavery (1865)</div>
                <div>Amendment 14: Equal Protection & Due Process (1868)</div>
                <div>Amendment 15: Voting Rights - Race (1870)</div>
                <div>Amendment 16: Income Tax (1913)</div>
                <div>Amendment 17: Direct Election of Senators (1913)</div>
                <div>Amendment 18: Prohibition (1919)</div>
                <div>Amendment 19: Women's Suffrage (1920)</div>
                <div>Amendment 20: Presidential Terms (1933)</div>
                <div>Amendment 21: Repeal of Prohibition (1933)</div>
                <div>Amendment 22: Presidential Term Limits (1951)</div>
                <div>Amendment 23: D.C. Electoral Votes (1961)</div>
                <div>Amendment 24: Poll Tax Prohibition (1964)</div>
                <div>Amendment 25: Presidential Succession (1967)</div>
                <div>Amendment 26: Voting Age 18 (1971)</div>
                <div>Amendment 27: Congressional Compensation (1992)</div>
              </div>
            </div>
          </div>

          <div className="hierarchy-level">
            <h3>2. Federal Statutory Law by Domain</h3>

            <div className="domains-grid">
              <div className="domain-card">
                <h4>Civil Rights & Equal Protection</h4>
                <ul>
                  <li>Civil Rights Act of 1964</li>
                  <li>Voting Rights Act of 1965</li>
                  <li>Fair Housing Act of 1968</li>
                  <li>Americans with Disabilities Act (1990)</li>
                </ul>
              </div>

              <div className="domain-card">
                <h4>Criminal Law & Procedure</h4>
                <ul>
                  <li>Federal Criminal Code (18 U.S.C.)</li>
                  <li>RICO (1970)</li>
                  <li>USA PATRIOT Act (2001)</li>
                  <li>First Step Act (2018)</li>
                </ul>
              </div>

              <div className="domain-card">
                <h4>Commerce & Business</h4>
                <ul>
                  <li>Sherman Antitrust Act (1890)</li>
                  <li>Clayton Act (1914)</li>
                  <li>Sarbanes-Oxley (2002)</li>
                  <li>Dodd-Frank (2010)</li>
                </ul>
              </div>

              <div className="domain-card">
                <h4>Labor & Employment</h4>
                <ul>
                  <li>Fair Labor Standards Act (1938)</li>
                  <li>OSHA (1970)</li>
                  <li>ERISA (1974)</li>
                  <li>FMLA (1993)</li>
                </ul>
              </div>

              <div className="domain-card">
                <h4>Intellectual Property</h4>
                <ul>
                  <li>Patent Act (35 U.S.C.)</li>
                  <li>Copyright Act (17 U.S.C.)</li>
                  <li>Trademark Act - Lanham Act (1946)</li>
                  <li>DMCA (1998)</li>
                </ul>
              </div>

              <div className="domain-card">
                <h4>Environmental Law</h4>
                <ul>
                  <li>NEPA (1969)</li>
                  <li>Clean Air Act (1970)</li>
                  <li>Clean Water Act (1972)</li>
                  <li>CERCLA/Superfund (1980)</li>
                </ul>
              </div>

              <div className="domain-card">
                <h4>Healthcare</h4>
                <ul>
                  <li>Medicare/Medicaid (1965)</li>
                  <li>HIPAA (1996)</li>
                  <li>ACA/Obamacare (2010)</li>
                  <li>21st Century Cures Act (2016)</li>
                </ul>
              </div>

              <div className="domain-card">
                <h4>Financial & Banking</h4>
                <ul>
                  <li>Federal Reserve Act (1913)</li>
                  <li>Securities Act (1933)</li>
                  <li>Securities Exchange Act (1934)</li>
                  <li>Dodd-Frank (2010)</li>
                </ul>
              </div>

              <div className="domain-card">
                <h4>Tax Law</h4>
                <ul>
                  <li>Internal Revenue Code (26 U.S.C.)</li>
                  <li>Tax Reform Act (1986)</li>
                  <li>Tax Cuts and Jobs Act (2017)</li>
                </ul>
              </div>

              <div className="domain-card">
                <h4>Immigration</h4>
                <ul>
                  <li>Immigration and Nationality Act (1952)</li>
                  <li>Immigration Reform (1986)</li>
                  <li>REAL ID Act (2005)</li>
                </ul>
              </div>

              <div className="domain-card">
                <h4>Education</h4>
                <ul>
                  <li>ESEA (1965)</li>
                  <li>IDEA (1975)</li>
                  <li>No Child Left Behind (2001)</li>
                  <li>Every Student Succeeds Act (2015)</li>
                </ul>
              </div>

              <div className="domain-card">
                <h4>Social Welfare</h4>
                <ul>
                  <li>Social Security Act (1935)</li>
                  <li>SSI (1972)</li>
                  <li>TANF (1996)</li>
                  <li>SNAP</li>
                </ul>
              </div>

              <div className="domain-card">
                <h4>Communications & Tech</h4>
                <ul>
                  <li>Communications Act (1934)</li>
                  <li>FOIA (1966)</li>
                  <li>Telecommunications Act (1996)</li>
                  <li>COPPA (1998)</li>
                </ul>
              </div>

              <div className="domain-card">
                <h4>National Security</h4>
                <ul>
                  <li>National Security Act (1947)</li>
                  <li>FISA (1978)</li>
                  <li>AUMF (2001)</li>
                  <li>USA FREEDOM Act (2015)</li>
                </ul>
              </div>

              <div className="domain-card">
                <h4>Energy</h4>
                <ul>
                  <li>Federal Power Act (1920)</li>
                  <li>Atomic Energy Act (1954)</li>
                  <li>Energy Policy Act (1992, 2005)</li>
                </ul>
              </div>

              <div className="domain-card">
                <h4>Housing</h4>
                <ul>
                  <li>National Housing Act (1934)</li>
                  <li>Fair Housing Act (1968)</li>
                  <li>Community Development (1974)</li>
                </ul>
              </div>

              <div className="domain-card">
                <h4>Transportation</h4>
                <ul>
                  <li>Federal-Aid Highway Act (1956)</li>
                  <li>DOT Act (1966)</li>
                  <li>Aviation Security Act (2001)</li>
                </ul>
              </div>

              <div className="domain-card">
                <h4>Consumer Protection</h4>
                <ul>
                  <li>Pure Food and Drug Act (1906)</li>
                  <li>Consumer Product Safety (1972)</li>
                  <li>Consumer Financial Protection (2010)</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="hierarchy-level">
            <h3>3. Administrative & Regulatory Law</h3>

            <div className="subsection">
              <h4>Major Federal Agencies</h4>
              <ul>
                <li>Federal Trade Commission (FTC) - 1914</li>
                <li>Securities and Exchange Commission (SEC) - 1934</li>
                <li>National Labor Relations Board (NLRB) - 1935</li>
                <li>Environmental Protection Agency (EPA) - 1970</li>
                <li>Occupational Safety and Health Administration (OSHA) - 1970</li>
                <li>Food and Drug Administration (FDA)</li>
                <li>Federal Communications Commission (FCC) - 1934</li>
                <li>Consumer Financial Protection Bureau (CFPB) - 2010</li>
                <li>Department of Homeland Security (DHS) - 2002</li>
              </ul>
            </div>

            <div className="subsection">
              <h4>Code of Federal Regulations (CFR)</h4>
              <p>Administrative rules and regulations promulgated by federal agencies across 50 titles</p>
            </div>

            <div className="subsection">
              <h4>Administrative Procedure Act (APA) (1946)</h4>
              <p>Governs the process by which federal agencies develop and issue regulations</p>
            </div>
          </div>

          <div className="hierarchy-level">
            <h3>4. Federal Case Law</h3>

            <div className="subsection">
              <h4>Federal Court System</h4>
              <ul>
                <li>Supreme Court of the United States (established 1789)</li>
                <li>U.S. Courts of Appeals (13 Circuit Courts)</li>
                <li>U.S. District Courts (94 districts)</li>
                <li>Specialized Federal Courts</li>
              </ul>
            </div>

            <div className="subsection">
              <h4>Landmark Supreme Court Cases</h4>
              <div className="cases-grid">
                <div className="case-item">
                  <strong>Marbury v. Madison (1803)</strong>
                  <p>Judicial Review</p>
                </div>
                <div className="case-item">
                  <strong>Brown v. Board of Education (1954)</strong>
                  <p>School Desegregation</p>
                </div>
                <div className="case-item">
                  <strong>Miranda v. Arizona (1966)</strong>
                  <p>Miranda Rights</p>
                </div>
                <div className="case-item">
                  <strong>Roe v. Wade (1973)</strong>
                  <p>Abortion Rights (overturned 2022)</p>
                </div>
                <div className="case-item">
                  <strong>Citizens United v. FEC (2010)</strong>
                  <p>Corporate Political Speech</p>
                </div>
                <div className="case-item">
                  <strong>Obergefell v. Hodges (2015)</strong>
                  <p>Same-Sex Marriage</p>
                </div>
              </div>
            </div>
          </div>

          <div className="hierarchy-level">
            <h3>5. State Law Systems</h3>

            <div className="subsection">
              <h4>Uniform Codes & Model Acts</h4>
              <ul>
                <li>Uniform Commercial Code (UCC) - Adopted by all states</li>
                <li>Model Penal Code</li>
                <li>Uniform Probate Code</li>
                <li>Uniform Partnership Act</li>
              </ul>
            </div>

            <div className="subsection">
              <h4>Areas of Primary State Jurisdiction</h4>
              <ul>
                <li>Criminal law (most crimes)</li>
                <li>Family law (marriage, divorce, custody)</li>
                <li>Property law (real estate, inheritance)</li>
                <li>Contract law (general principles)</li>
                <li>Tort law (personal injury, negligence)</li>
                <li>Corporate law (incorporation, governance)</li>
              </ul>
            </div>
          </div>

          <div className="hierarchy-level">
            <h3>6. International & Treaty Law</h3>

            <div className="subsection">
              <h4>Major Treaties & Agreements</h4>
              <ul>
                <li>United Nations Charter (1945)</li>
                <li>Universal Declaration of Human Rights (1948)</li>
                <li>Geneva Conventions (1949)</li>
                <li>NATO (1949)</li>
                <li>International Covenant on Civil and Political Rights (1966)</li>
                <li>Trade Agreements (NAFTA/USMCA, WTO)</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="legal-section">
          <h2>Legal Hierarchy & Precedence</h2>
          <div className="precedence-list">
            <div className="precedence-item level-1">1. U.S. Constitution</div>
            <div className="precedence-item level-2">2. Federal Statutes & Treaties</div>
            <div className="precedence-item level-3">3. Federal Regulations</div>
            <div className="precedence-item level-4">4. Federal Case Law</div>
            <div className="precedence-item level-5">5. State Constitutions</div>
            <div className="precedence-item level-6">6. State Statutes</div>
            <div className="precedence-item level-7">7. State Regulations</div>
            <div className="precedence-item level-8">8. State Case Law</div>
            <div className="precedence-item level-9">9. Local Ordinances</div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default LegalFoundations;
